const config = {
  delay: 100,
  classNames: {
    overlay: 'overlay',
  },
};

export default config;
